import * as types from "../constants/ActionTypes.js";

class TabulationHandler {
  getTabulatedInfoByContact(tabulatedInfos, contact) {
    const hasContact = Boolean(contact);
    const hasTabulatedInfos = Boolean(tabulatedInfos);
    if (!hasContact || !hasTabulatedInfos) return [];
    return tabulatedInfos[contact.idatendimento] || [];
  }
  getNumbersOfClassifications(tabulatedInfos, contact) {
    const tabulatedInfo = this.getTabulatedInfoByContact(
      tabulatedInfos,
      contact,
    );
    const hasTabulatedInfo = Boolean(tabulatedInfo);
    if (!hasTabulatedInfo) return 0;
    return tabulatedInfo.length;
  }
  isExcededNumberOfClassifications(tabulatedInfos, contact, informationuser) {
    const numbersOfClassifications = this.getNumbersOfClassifications(
      tabulatedInfos,
      contact,
    );
    const hasInformationUser = Boolean(informationuser);
    if (!hasInformationUser) return false;
    const hasClassificationCount = Boolean(informationuser.classificationcount);
    if (!hasClassificationCount) return false;
    return numbersOfClassifications >= informationuser.classificationcount;
  }
  generateTabulatedId(pathId) {
    const hasSeparationId = pathId.includes("&");
    if (!hasSeparationId) return pathId;
    const idsArray = pathId.split("&");
    const hasMoreThanOneId = idsArray.length > 1;
    if (!hasMoreThanOneId) return pathId;
    return `${idsArray[0]}&${idsArray[idsArray.length - 1]}`;
  }
  generateLabelOfTabulation(path) {
    const hasSeparationLabel = path.includes(" >");
    if (!hasSeparationLabel) return path;
    const labelsArray = path.split(" > ");
    const hasMoreThanOneLabel = labelsArray.length > 1;
    if (!hasMoreThanOneLabel) return path;
    return `${labelsArray[0]} > ${labelsArray[labelsArray.length - 1]}`;
  }
  hasTabulatedInfos(contactTabulatedInfo) {
    return Array.isArray(contactTabulatedInfo);
  }
  filterSelectedNodes(selectedNodesTree, contactTabulatedInfo) {
    const hasSelectedNodesTree = Array.isArray(selectedNodesTree);
    if (!hasSelectedNodesTree || !Boolean(contactTabulatedInfo))
      return selectedNodesTree;
    return selectedNodesTree.filter((node) => {
      if (!this.hasTabulatedInfos(contactTabulatedInfo)) {
        return true;
      }
      return !contactTabulatedInfo.some(
        (tabulatedInfo) =>
          tabulatedInfo.id === this.generateTabulatedId(node.pathId),
      );
    });
  }

  formatTabulatedInfos(selectedNodesTree, contactTabulatedInfo) {
    if (!this.hasTabulatedInfos(contactTabulatedInfo))
      return selectedNodesTree.map((node) => ({
        label: this.generateLabelOfTabulation(node.path),
        id: this.generateTabulatedId(node.pathId),
      }));

    return [
      ...contactTabulatedInfo,
      ...selectedNodesTree.map((node) => ({
        label: this.generateLabelOfTabulation(node.path),
        id: this.generateTabulatedId(node.pathId),
      })),
    ];
  }

  getInitialTabulatedInfos(messages) {
    const hasMessages = Array.isArray(messages) && messages.length > 0;
    if (!hasMessages) return [];

    const tabulatedInfosMap = new Map();

    messages[0].classificacoes.forEach((item) => {
      const hasCategoria =
        Boolean(item.categoria) &&
        (Boolean(item.categoria.id) || item.categoria.id === 0);
      const hasSubcateregoria =
        Boolean(item.subcategoria) &&
        (Boolean(item.subcategoria.id) || item.subcategoria.id === 0);
      let id = `${item.categoria ? item.categoria.id : ""}&${item.subcategoria ? item.subcategoria.id : ""}`;
      let label = `${item.categoria ? item.categoria.descricao : ""} > ${item.subcategoria ? item.subcategoria.descricao : ""}`;
      if (!hasCategoria || !hasSubcateregoria) {
        id = `${item.categoria ? item.categoria.id : ""}${item.subcategoria ? item.subcategoria.id : ""}`;
        label = `${item.categoria ? item.categoria.descricao : ""}${item.subcategoria ? item.subcategoria.descricao : ""}`;
      }
      if (!tabulatedInfosMap.has(id)) {
        tabulatedInfosMap.set(id, {
          id,
          label,
        });
      }
    });

    return Array.from(tabulatedInfosMap.values());
  }

  editTabulatedInfos(cdr, tabulatedInfos = []) {
    return {
      type: types.EDIT_TABULATED_INFOS,
      cdr,
      tabulatedInfos,
    };
  }

  hasAlreadyThisClassification(selectedNodes, tabulatedInfos, contact) {
    const hasSelectedNodes = Boolean(selectedNodes);
    const hasTabulatedInfos = Boolean(tabulatedInfos);
    const hasContact = Boolean(contact);
    if (!hasSelectedNodes || !hasTabulatedInfos || !hasContact) return false;
    const tabulatedInfo = tabulatedInfos[contact.idatendimento];
    const hasTabulatedInfo = Boolean(tabulatedInfo);
    if (!hasTabulatedInfo) return false;
    return tabulatedInfo.some((item) =>
      selectedNodes.some(
        (node) =>
          this.generateTabulatedId(node.pathId) ===
          this.generateTabulatedId(item.id),
      ),
    );
  }

  hasMoreClassificationsThanAllowed(
    selectedNodes,
    tabulatedInfos,
    contact,
    informationuser,
  ) {
    const hasSelectedNodes =
      Boolean(selectedNodes) && Array.isArray(selectedNodes);
    const hasInformationUser = Boolean(informationuser);
    if (!hasSelectedNodes || !hasInformationUser) return false;
    const numberOfSelectedNodes = selectedNodes.length;
    const numbersOfClassifications = this.getNumbersOfClassifications(
      tabulatedInfos,
      contact,
    );

    if (informationuser.classificationcount === 0) return false;
    return (
      numberOfSelectedNodes + numbersOfClassifications >
      informationuser.classificationcount
    );
  }

  hasAnyTabulatedInfo(tabulatedInfos, contact) {
    const tabulatedInfo = this.getTabulatedInfoByContact(
      tabulatedInfos,
      contact,
    );
    return Array.isArray(tabulatedInfo) && tabulatedInfo.length > 0;
  }

  removeClassificationFromTabulatedInfo(cdr, idPath) {
    return {
      type: types.REMOVE_CLASSIFICATION_FROM_TABULATED_INFO,
      cdr,
      idPath: this.generateTabulatedId(idPath),
    };
  }
}

export const tabulationHandler = new TabulationHandler();
